import type { BrandSpecial } from '@iheartjane/data-access';
import type { PriceId, QualifyingStatusEnum } from '@iheartjane/types';

/**
 * Price ids a brand special applies to, read from its serialized
 * `applicable_weights`: a flat list for product specials, or `qualify` /
 * `discount` sides for bundle specials (`discount` once qualified or applied).
 * Returns `[]` when the special carries no weight list.
 */
export const getPriceIdsForBrandSpecial = (
  brandSpecial?: BrandSpecial,
  qualifyingStatus?: QualifyingStatusEnum
): PriceId[] => {
  const applicableWeights = brandSpecial?.applicable_weights;
  if (!applicableWeights) return [];

  if (brandSpecial.special_type === 'product') {
    return Array.isArray(applicableWeights)
      ? (applicableWeights as PriceId[])
      : [];
  }

  if (
    brandSpecial.special_type === 'buy_x_and_save' ||
    brandSpecial.special_type === 'buy_x_get_y'
  ) {
    if (Array.isArray(applicableWeights)) return [];

    const isQualified =
      qualifyingStatus === 'qualified' || qualifyingStatus === 'applied';
    const weights = isQualified
      ? applicableWeights.discount
      : applicableWeights.qualify;

    return (weights ?? []) as PriceId[];
  }

  return [];
};
